// extracted by css-extract-rspack-plugin
export default {"cls1":"Tabs-cls1_Imx","cls2":"Tabs-cls2_RPk Tabs-cls1_Imx"};